import React, {useRef, useState, useEffect} from "react";

import "./FileUpload.css";

import Button from "./Button";

const FileUpload = (props) => {
  const [file, setFile] = useState();
  const [isValid, setIsValid] = useState(false);
  const filePickerRef = useRef();

  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = isValid;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setFile(pickedFile);
      props.setFileName(pickedFile);
      setIsValid(true);
      fileIsValid = true;
    } else {
      setIsValid(false);
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  const filePickerHandler = () => {
    filePickerRef.current.click();
  };

  useEffect(() => {
    if (props.file) {
      setFile(props.file);
      props.setFileName(props.file);
    } else {
      setFile();
      props.setFileName();
    }
  }, [props]);

  return (
    <div className="filepicker">
      <input
        type="file"
        id={props.id}
        ref={filePickerRef}
        style={{display: "none"}}
        accept={props.accept ? props.accept : ".pdf"}
        onChange={pickedHandler}
      ></input>
      {!file && <h6>Select a PDF file only...</h6>}
      {file && <h6>{file.name}</h6>}
      <Button
        type="button"
        disabled={props.disabled}
        onClick={filePickerHandler}
      >
        Choose File
      </Button>
    </div>
  );
};

export default React.memo(FileUpload);
